import { useEffect } from "react";
import { input } from "../../helper";
import "./mcqCard.css";
import Option from "../Option";
import Question from "../Question";

function McqCard({ color = "", data, number, setCorrectAnswer }) {
  const handleClick = (e) => {
    setCorrectAnswer(e.target.value);
  };
  
  useEffect(() => {
    const radios = document.querySelectorAll(".question-fields .radio");
    radios.forEach((radio) => {
      radio.checked = false;
    });
  }, [number]);

  return (
    <Question
      color={color}
      index={number}
      question={data}
      label={"Select Single Option"}
    >
      {data.options.map((option, index) => {
        return (
          <Option
            key={index}
            type="radio"
            option={option}
            image={data.images && data.images[`op${index + 1}`]}
            select={handleClick}
            styles={input(color)}
            checkMarkStyles={input(color, index)}
          />
        );
      })}
    </Question>
  );
}

export default McqCard;
